import { putProfileInfo } from 'api/profilepage';
import axios, { AxiosError } from 'axios';
import { usePopup } from 'context/PopupContext/PopupContext';
import { useMutation } from 'react-query';

export const useProfileDataMutation = () => {
  const { showPopup } = usePopup();
  const { mutate, status, isError } = useMutation(putProfileInfo, {
    onError: (e: AxiosError | Error) => {
      console.error('Error:', e);
      if (axios.isAxiosError(e)) {
        showPopup({
          message: e.response?.data?.message || e.message,
          type: 'ERROR',
        });
      }
    },
  });

  return {
    mutate,
    isError,
    status,
  };
};
